import { setItemInSessionStorage } from '../../sessionStorage/sessionStorage.ts';

let orgId: string | undefined;
function setOrgId(id: string): void {
    orgId = id;
}
function getOrgId(): string | undefined {
    return orgId;
}

let messagingUrl: string | undefined;
function setMessagingUrl(url: string): void {
    messagingUrl = url;
}
function getMessagingUrl(): string | undefined {
    return messagingUrl;
}

let esDeveloperName: string | undefined;
function setEsDeveloperName(name: string): void {
    esDeveloperName = name;
}
function getEsDeveloperName(): string | undefined {
    return esDeveloperName;
}

let jwt: string | undefined;
function storeJwt(token: string): void {
    jwt = token;
    setItemInSessionStorage('salesforceJwt', token);
}
function getJwt(): string | undefined {
    return jwt;
}

let lastEventId: string | undefined;
function setLastEventId(id: string): void {
    lastEventId = id;
}
function getLastEventId(): string | undefined {
    return lastEventId;
}

let conversationId: string | undefined;
function setConversationId(id: string): void {
    conversationId = id;
}
function getConversationId(): string | undefined {
    return conversationId;
}

function clearInMemoryData(): void {
    orgId = undefined;
    messagingUrl = undefined;
    esDeveloperName = undefined;
    jwt = undefined;
    conversationId = undefined;
    lastEventId = undefined;
}

export {
    clearInMemoryData,
    getConversationId,
    getEsDeveloperName,
    getJwt,
    getLastEventId,
    getMessagingUrl,
    getOrgId,
    setConversationId,
    setEsDeveloperName,
    setLastEventId,
    setMessagingUrl,
    setOrgId,
    storeJwt,
};
